var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.97 10.5v5c0 2.83 0 4.25.88 5.12.87.88 2.29.88 5.12.88h6c2.83 0 4.24 0 5.12-.88.88-.87.88-2.29.88-5.12v-5",
    stroke: "#141B34",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.97 17c-.69.6-1.78 1-3 1a4.6 4.6 0 01-3-1",
    stroke: "#141B34",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 8.42c-.28 1.02-1.3 2.77-3.25 3.03a4.51 4.51 0 01-3.36-.84 5.19 5.19 0 01-1.41-1.58c-.2-.51.03-1.61.2-2.06l.69-1.98c.16-.5.55-1.67.96-2.07.4-.4 1.2-.42 1.54-.42h7c1.8.03 5.75-.01 6.53 0 .78.02 1.25.67 1.38.95C21.55 6.27 22 7.88 22 8.57c-.15.73-.78 2.12-3 2.72-2.3.64-3.61-.6-4.02-1.06m-5.82 0c.32.4 1.34 1.2 2.82 1.22a4.62 4.62 0 003.2-1.53c.13-.15.4-.6.7-1.5",
    stroke: "#141B34",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.3dc220fc968592bb3960b634ff0b77d9.svg";
export { ForwardRef as ReactComponent };